// extracted by mini-css-extract-plugin
module.exports = {"skillCard":"Scores_skill-card__1OFwg","technical":"Scores_technical__2LI0V","personal":"Scores_personal__3Q0Se"};